import { memo } from 'react';
import styles from './Advt.module.css';

const Advt = memo(({ advtInfo, titleFontSize }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['title']}>
        {advtInfo.label && (
          <>
            <span className={styles['nominations']}>
              <div className={styles.shadow}>НОМИНАЦИЯ</div>НОМИНАЦИЯ
            </span>
            <span
              className={styles['label']}
              style={{
                fontSize: `${titleFontSize}rem`,
                lineHeight: `${titleFontSize}rem`,
              }}>
              <div
                className={styles.shadow}
                style={{
                  fontSize: `${titleFontSize}rem`,
                  lineHeight: `${titleFontSize}rem`,
                }}>
                {advtInfo.label}
              </div>
              {advtInfo.label}
            </span>
          </>
        )}
      </div>
    </div>
  );
});

export default Advt;
